import { CityQuestStatusEnum } from '@escapenavigator/types/dist/city-quest/enum/city-quest-status.enum';
import { PortalMaterialOrderStatusEnum } from '@escapenavigator/types/dist/partners-portal/enum/portal-material-order-status.enum';
import { Badge } from '@mantine/core';

import { t } from '../dictionary';

const questColors: Record<CityQuestStatusEnum, string> = {
    [CityQuestStatusEnum.DRAFT]: 'gray',
    [CityQuestStatusEnum.NEED_REVIEW]: 'yellow',
    [CityQuestStatusEnum.REJECTED]: 'red',
    [CityQuestStatusEnum.READY]: 'indigo',
    [CityQuestStatusEnum.PAUSED]: 'blue',
};

export const StoryStatusBadge = ({ status }: { status: CityQuestStatusEnum | string }) => (
    <Badge variant='light' color={questColors[status as CityQuestStatusEnum] || 'gray'}>
        {t.stories.statuses[status as keyof typeof t.stories.statuses] || status}
    </Badge>
);

const materialColors: Record<PortalMaterialOrderStatusEnum, string> = {
    [PortalMaterialOrderStatusEnum.NEW]: 'blue',
    [PortalMaterialOrderStatusEnum.PROCESSING]: 'yellow',
    [PortalMaterialOrderStatusEnum.SHIPPED]: 'grape',
    [PortalMaterialOrderStatusEnum.DONE]: 'teal',
    [PortalMaterialOrderStatusEnum.CANCELED]: 'gray',
};

export const MaterialStatusBadge = ({ status }: { status: PortalMaterialOrderStatusEnum }) => (
    <Badge variant='light' color={materialColors[status]}>
        {t.materials.statuses[status]}
    </Badge>
);
